module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetHigh@2x.2146c9c.jpg";